import { Buffer } from "buffer";
import { format } from "date-fns";
import { saveAs } from "file-saver";
import {
  GetPptxFromProjectDetailsDocument,
  type GetPptxFromProjectDetailsQuery,
} from "graphql/__generated__/graphql";
import { useMe } from "hooks";
import { useTrackEvent } from "libs/tracking";
import { useState } from "react";
import { useClient } from "urql";

export const useDownloadProjectDetailsPptx = (projectId: string) => {
  const urqlClient = useClient();

  const [isLoading, setIsLoading] = useState(false);
  const { trackEvent } = useTrackEvent();

  const { me } = useMe();
  const date = new Date();

  const downloadPPT = async () => {
    try {
      setIsLoading(true);

      const data = await urqlClient
        .query<GetPptxFromProjectDetailsQuery>(
          GetPptxFromProjectDetailsDocument,
          { projectId },
          {
            requestPolicy: "network-only",
          },
        )
        .toPromise();
      const ppt = data.data?.ppt;
      if (!ppt) return;

      const buffer = Buffer.from(ppt, "base64");

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.presentationml.presentation;charset=utf-8",
      });
      saveAs(
        blob,
        `Présentation_Copil_${me?.partnerName}_${format(
          date,
          "yyyyMMdd",
        )}.pptx`,
      );
    } finally {
      await trackEvent("download", "download-ppt");
      setIsLoading(false);
    }
  };

  return { downloadPPT, isLoading };
};
